import { render } from "./OrderCreatePage.vue?vue&type=template&id=ac30c346"
import script from "./OrderCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__